import React from 'react';
import { Link } from 'react-router-dom';
import { PRACTICE, BRAND_TAGLINE } from '../../content/site';
import { useLanguage } from '../../context/LanguageContext';
export function Wordmark({
  tone = 'dark',
  size = 'md'
}: {
  tone?: 'dark' | 'light';
  size?: 'sm' | 'md' | 'lg';
}) {
  const {
    language
  } = useLanguage();
  const main = tone === 'dark' ? 'text-espresso' : 'text-pearl';
  const sizes = {
    sm: 'text-base',
    md: 'text-lg sm:text-xl',
    lg: 'text-2xl'
  };
  return <Link to="/" aria-label={PRACTICE.nameTitle} className="group inline-flex flex-col leading-none" data-id="element-177" data-mp="1waj33i4eqf3e">
      <span className={`font-serif font-normal tracking-[0.18em] ${sizes[size]} ${main}`} data-id="element-178" data-mp="2a2foz4fhfsrc">
        {PRACTICE.name}
      </span>
      <span className="mt-1.5 text-[9px] font-semibold uppercase tracking-[0.24em] text-bronze" data-id="element-179" data-mp="258upt925ksqk">
        {BRAND_TAGLINE[language]}
      </span>
    </Link>;
}